<template>
  <div class="wrapper add-knowledge">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.skills.modal.title', 'Edit skills')"
      :ok-title="$t('generic.save', 'Save')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @hidden="$emit('closeModal')"
      @ok="handleOk"
      @show="load()"
    >
      <label for="speakSelect">{{ $t('pages.user-cv.skills.modal.skills', 'Skills') }}</label>
      <multiselect
        v-model="skillsSelected"
        :options="skillsOptions"
        :multiple="true"
        :taggable="true"
        :placeholder="$t('pages.user-cv.skills.modal.skills.placeholder', 'Write a skill')"
        :tag-placeholder="$t('pages.user-cv.skills.modal.skills.tag-placeholder', 'Press enter to create a label')"
        @tag="addTag"
      >
        <template slot="noOptions">
          {{ $t('pages.user-cv.skills.modal.skills.no-options', 'Write a skill and press enter') }}
        </template>
      </multiselect>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    skills: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      skillsSelected: null,
      skillsOptions: [],
    }
  },
  methods: {
     handleOk() {
      this.axios.put('/cv/update/skills', { skills: JSON.stringify(this.skillsSelected) })
        .then(response => {
          this.$emit('updateCv', response.data);
          this.$emit('closeModal');
          this.$toastNotification('success', '', this.$t('pages.user-cv.profile-update.success', 'Profile updated successfully!'));
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
    load() {
      if(this.skills) {
        this.skillsSelected = JSON.parse(this.skills);
      }
    },
    addTag (newTag) {
      const tag = newTag;
      if(!this.skillsSelected) {
        this.skillsSelected = [];
      }
      this.skillsSelected.push(tag)
    }
  }
}
</script>

<style lang="scss">
  .add-knowledge {
    font-size: 0.9rem;
  }
</style>
